import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import {StepService} from '../../services';

@Injectable({
    providedIn: 'root'
})
export class ProjectStepGuard  {
    private router = inject(Router);
    private stepService = inject(StepService);


    // Route guard when entering
    canActivate(route: ActivatedRouteSnapshot): UrlTree | boolean {
        const stepId = parseInt(route.params.stepId, 10);
        const projectId = route.params.projectId;

        if (!this.stepService.isValidStep(stepId)) {
            return this.router.parseUrl(`/project/${projectId}/step/1`);
        }
        return true;
    }

}
